import {
    SETTINGS_SET_VALUE
} from '../../action-types';

export function setSettingsValue( key, value ){
    return {
        type: SETTINGS_SET_VALUE,
        key: key,
        value: value
    }
}


/** WEBPACK FOOTER **
 ** ./src/state/actions/settings/index.js
 **/